import "./i18n";
import "./index.css";
import { App } from "./App";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { store } from "./redux_config";
import React, { Suspense } from "react";
import { PageLoader } from "./core/components";

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback={<PageLoader />}>
      <Provider store={store}>
        <App />
      </Provider>
    </Suspense>
  </React.StrictMode>,
  document.getElementById("root")
);
